




import Vue from 'vue'

export default Vue.extend({
  data() {
    return {}
  },
  props: {
    children: {
      type: [String, Object],
      default: 'div',
    },
  },
  name: 'ModalBody',
})
